export default __webpack_public_path__ + "static/media/dollar-coin.068786bc.svg";